/**
 * Given json string replaces all occurrences of '<' or '>' as well as their html entities (just to be safe)
 * @param json the json input as a string
 */
export default (json ?: string) : string => (json?.replace(/(<|>|&#60;|&#62;)/g, '') || '')
